import {
  VALIDATE_ADDRESS_ENDPOINT,
  RELATE_LOCATIONS_TO_CART_ADDRESS_ENDPOINT
} from 'bento-ordering/base/constants/endpoints';
import { apiAction } from 'bento-ordering/base/utils/apiHelpers';
import {
  VALIDATE_ADDRESS_REQUEST,
  VALIDATE_ADDRESS_SUCCESS,
  VALIDATE_ADDRESS_FAILURE,
  RELATE_LOCATIONS_TO_CART_REQUEST,
  RELATE_LOCATIONS_TO_CART_SUCCESS,
  RELATE_LOCATIONS_TO_CART_FAILURE
} from 'bento-ordering/locations/constants/actionTypes';
import getGroupOrderQueryParam from 'bento-ordering/base/utils/getGroupOrderQueryParam';

export const validateAddressInDeliveryZone = parsedAddress => (
  dispatch,
  getState
) => {
  const state = getState();
  const endpoint = VALIDATE_ADDRESS_ENDPOINT;
  const groupOrder = getGroupOrderQueryParam(state);
  const queryParams = { ...parsedAddress, ...groupOrder };

  return dispatch(
    apiAction(
      endpoint,
      'GET',
      [
        VALIDATE_ADDRESS_REQUEST,
        VALIDATE_ADDRESS_SUCCESS,
        VALIDATE_ADDRESS_FAILURE
      ],
      null,
      queryParams
    )
  );
};

export const setCartAddressAndGetLocationsInRelation = parsedAddress => dispatch => {
  const payload = parsedAddress;
  const endpoint = RELATE_LOCATIONS_TO_CART_ADDRESS_ENDPOINT;
  return dispatch(
    apiAction(
      endpoint,
      'POST',
      [
        RELATE_LOCATIONS_TO_CART_REQUEST,
        {
          type: RELATE_LOCATIONS_TO_CART_SUCCESS,
          payload: async (action, state, response) => {
            const json = await response.json();

            return {
              ...json,
              googlePlaceId: parsedAddress.shipping_google_place_id
            };
          }
        },
        RELATE_LOCATIONS_TO_CART_FAILURE
      ],
      payload
    )
  );
};
